const reportsPage = {
  report: 'Reports',
};

export default reportsPage;
